import { useAppStore } from '../zustand/store';
import { useMemo } from 'react';

export const useAuthState = () => {
  const token = useAppStore((state) => state.token);
  return useMemo(() => ({ token }), [token]);
};

export const useProposalState = () => {
  const proposal = useAppStore((state) => state.proposal);
  const loading = useAppStore((state) => state.loading);
  return useMemo(() => ({ proposal, loading }), [proposal, loading]);
};

export const useSelectedLoanSimulationState = () => {
  const loanSimulation = useAppStore((state) => state.loanSimulation);
  return useMemo(() => ({ loanSimulation }), [loanSimulation]);
};

export const useOptionsState = () => {
  const terms = useAppStore((state) => state.terms);
  const privatePolicy = useAppStore((state) => state.privatePolicy);
  return useMemo(() => ({ terms, privatePolicy }), [terms, privatePolicy]);
};

export const useErrorState = () => {
  const error = useAppStore((state) => state.error);
  const etapa = useAppStore((state) => state.etapa);
  return useMemo(() => ({ error, etapa }), [error, etapa]);
};

export const useValidationState = () => {
  const isConfirmed = useAppStore((state) => state.isConfirmed);
  return useMemo(() => ({ validation: isConfirmed }), [isConfirmed]);
};

export const useConfirmedState = () => {
  const confirmed = useAppStore((state) => state.confirmed);
  return useMemo(() => ({ confirmed }), [confirmed]);
};

export const useHistoryState = () => {
  const history = useAppStore((state) => state.history);
  return useMemo(() => ({ history }), [history]);
};

export const useSettingsState = () => {
  const paymentPoolingIntervals = useAppStore(
    (state) => state.paymentPoolingIntervals
  );
  const emailValidationInterval = useAppStore(
    (state) => state.emailValidationInterval
  );
  const idwallPoolingIntervals = useAppStore(
    (state) => state.idwallPoolingIntervals
  );

  return useMemo(
    () => ({
      paymentPoolingIntervals,
      emailValidationInterval,
      idwallPoolingIntervals,
    }),
    [paymentPoolingIntervals, emailValidationInterval, idwallPoolingIntervals]
  );
};

export const useUtilsState = () => {
  const footerHeight = useAppStore((state) => state.footerHeight);
  return useMemo(() => ({ footerHeight }), [footerHeight]);
};

export const useFaqState = () => {
  const faqData = useAppStore((state) => state.faqData);
  return useMemo(() => ({ faqData }), [faqData]);
};

export const useAppState = () => {
  const auth = useAuthState();
  const proposal = useProposalState();
  const selectedLoanSimulation = useSelectedLoanSimulationState();
  const options = useOptionsState();
  const error = useErrorState();
  const validation = useValidationState();
  const confirmed = useConfirmedState();
  const history = useHistoryState();
  const settings = useSettingsState();
  const utils = useUtilsState();
  const faq = useFaqState();

  return {
    ...auth,
    ...proposal,
    ...selectedLoanSimulation,
    ...options,
    ...error,
    ...validation,
    ...confirmed,
    ...history,
    ...settings,
    ...utils,
    ...faq,
  };
};
